































import { computed, defineComponent, PropType, ref, toRefs, watch } from '@vue/composition-api';
import IdentityList from '../common/list.vue';
import { IdentityItem } from '../types';
import ALink from '@/components/common/a-link/a-link.vue';
import OperationList from '@/components/common/operation-list/index.vue';
import { i18n } from '@tt4b/ttam-i18n';
import { trackEvent } from './../../../utils/index';
import SelectNoDataIcon from '@tt4b/ttam-assets/src/svgs/select-no-data.svg';
import {
  AdgroupFormData,
  BC_IDENTITY_TYPES_LIST,
  IDENTITY_TYPE_MAP,
  CampaignFormData,
  CreateMode,
} from '@tt4b/ttam-enums';
import { parseUrlSearch } from '@tt4b/ttam-utils';
import { useIdentityInfoApi, useStdAdgroupIs, useAdgroupCommonAlertInfo, useAdgroupMode } from '@tt4b/ttam-hooks';
const name = 'ttam-sale-identity-tiktok-list';

export default defineComponent({
  name,
  components: { IdentityList, ALink, OperationList, SelectNoDataIcon },
  props: {
    dataSource: {
      type: Array as PropType<IdentityItem[]>,
      default: () => [],
    },
    value: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    isDataSourceReady: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const keyword = ref('');
    const identityRef = ref(null);
    const { dataSource, value, createMode, campaignData, adgroupData, disabled, isDataSourceReady } = toRefs(props);
    const { isEdit } = useAdgroupMode({ createMode });
    const { addAdgroupAlertInfo } = useAdgroupCommonAlertInfo();
    // edit回显的信息
    const identityInfoData = ref({
      avatarIcon: {
        width: 20,
        height: 20,
        webUri: '',
        url: '',
      },
      displayName: '',
      identityId: '',
    });
    // status get
    const { isLiveAds, isProductSales } = useStdAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });
    // LSA下没有Identity权限，要重新获取identity-name展示
    const noAccessIdentityOfLiveType = computed(() =>
      Boolean(
        isProductSales.value &&
          isLiveAds.value &&
          isEdit.value &&
          isDataSourceReady.value &&
          disabled.value &&
          dataSource.value &&
          !dataSource.value?.find?.(i => i.id === value.value),
      ),
    );
    const onChange = (val: IdentityItem) => {
      emit('input', val.id);
      emit('identity-change', val);
    };

    const onPopoverCTA = (val: IdentityItem) => {
      emit('identity-popover-click', val);
    };

    const onLink = () => {
      emit('add');
    };

    const onRefresh = () => {
      emit('refresh');
    };

    const onAdd = () => {
      emit('add');
    };

    const operationList = computed(() => [
      {
        icon: 'vi-icon2-refresh',
        click: () => {
          onRefresh();
          trackEvent('create_ad_refresh_identity');
          identityRef.value?.onFocus();
        },
        disabled: props.disabled,
        hint: i18n.t('adgroup_convert-refresh'),
      },
      {
        icon: 'vi-icon2-add',
        click: () => {
          onAdd();
          trackEvent('add_identity');
        },
        disabled: props.disabled,
        hint: i18n.t('common_create'),
      },
    ]);

    const onKeywordInput = (val: string) => {
      keyword.value = val;
    };
    watch(
      noAccessIdentityOfLiveType,
      async val => {
        if (val) {
          try {
            const { identityType, identityBcId, identityTtsShopId } = adgroupData.value as any;
            let opt: any = {
              identityId: value.value,
              identityType,
            };
            if (BC_IDENTITY_TYPES_LIST.includes(identityType) && identityBcId) {
              opt.identityBcId = identityBcId;
            }
            if (identityType === IDENTITY_TYPE_MAP.TTS_TT && identityTtsShopId) {
              opt.identityTtsShopId = identityTtsShopId;
            }
            const { attach_uid } = parseUrlSearch(window.location.search);
            if (attach_uid) {
              opt.attachUid = attach_uid;
            }
            const info = await useIdentityInfoApi(opt);
            const { identityInfo = {} } = info;
            if (identityInfo?.identityId) {
              identityInfoData.value.displayName = identityInfo.displayName;
              identityInfoData.value.avatarIcon = identityInfo.avatarIcon;
              identityInfoData.value.identityId = identityInfo.identityId;
              addAdgroupAlertInfo({
                text: i18n.t('module_ad_no_permission_identity_edit_banner_text'),
                type: 'error',
                show: true,
                key: 'module_ad_no_permission_identity_edit_banner_text',
              });
            } else if (identityType === IDENTITY_TYPE_MAP.TTS_TT) {
              // identity 解绑
              addAdgroupAlertInfo({
                text: i18n.t('module_adgroup_identity_unlink_edit_banner'),
                type: 'error',
                show: true,
                key: 'module_adgroup_identity_unlink_edit_banner',
              });
            }
          } catch (error) {}
        }
      },
      {
        immediate: true,
      },
    );
    // 没有权限的也要回显
    const showNoAccessIdentityInfo = computed(() =>
      Boolean(noAccessIdentityOfLiveType.value && identityInfoData.value.identityId),
    );
    return {
      name,
      identityRef,
      keyword,
      operationList,
      onAdd,
      onLink,
      onChange,
      onRefresh,
      onPopoverCTA,
      onKeywordInput,
      identityInfoData,
      showNoAccessIdentityInfo,
    };
  },
});
